// import _ from "lodash";

export class Service {

    constructor(axios, endpoint) {
        this.data = [];
        this.fieldPrimaryKey = '';
        this.fields = [];
        this.mostrarAcciones = true;
        this.hardDelete = false;
        this.perPage = 15;
        this.currentPage = 1;
        this.filter = null;
        this.filterOn = []
        this.loading = false;
        this.endpoint = endpoint;
        this.http = axios;
    }

    getUrl(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_URL + this.endpoint;
        if (pathParam != null) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }

        if (queryParams) {
            const parameters = new URLSearchParams(queryParams);
            url += '?'
            url += parameters.toString();
        }

        return url.toString();
    }

    /*
    queryParams is Array
    * */
    getUrlQuery(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_URL + this.endpoint;
        if (pathParam != null) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }

        if (pathParam != null) {
            const params = queryParams.join('/');
            url += params
        }

        return url.toString();
    }

    getUrlBase(pathParam, queryParams) {

        let url = process.env.VUE_APP_API_BASE_URL + '/' + this.endpoint;
        if (pathParam) {
            url += Array.isArray(pathParam) ? pathParam.join('/') : pathParam;
        }
        if (queryParams) {
            const parameters = new URLSearchParams(queryParams);
            url += '?'
            url += parameters.toString();
        }

        return url.toString();
    }

    onError(error) {

        if (error.response != null && error.response.data != null) {
            if (error.response.data.msj != null)
                throw new Error(error.response.data.msj)
            else if (error.response.data.detail != null)
                throw new Error(error.response.data.detail)
            else {
                throw new Error("Ocurrio un error al consultar el servicio")
            }
        } else {
            console.error(error);
            throw new Error("Ocurrio un error al consultar el servicio")
        }
    }

    onData(response) {
        return response.data;
    }


    onStart() {
        this.loading = true;
    }

    onFinaly() {
        this.loading = false;
    }

    actualizar(object, params, config) {
        this.onStart();
        return this.http.put(this.getUrl(['actualizar', object[this.fieldPrimaryKey]]), object, config)
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }


}
